export default "__VITE_ASSET__BppB2zVh__"